// src/App.js
import React, { useState, useEffect } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header';
import Map from './components/Map';
import Filters from './components/Filters';
import NodesTable from './components/NodesTable';
import DataSource from './components/DataSource';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NodeDetails from './components/NodeDetails';

const nodesData = [
  {
    status: 'reporting',
    node: 'W068',
    city: 'Eugene, Oregon',
    gps: '44.046679825, -123.073718595',
  },
  {
    status: 'reporting',
    node: 'W06F',
    city: 'Lakeview, Montana',
    gps: '44.598866276, -111.812532858',
  },
  {
    status: 'reporting',
    node: 'W085',
    city: 'Grand Forks, North Dakota',
    gps: '47.92189466108028, -97.08656737454763',
  },
  {
    status: 'reporting',
    node: 'W06A',
    city: 'Lac du Flambeau, Wisconsin',
    gps: '46.029961371, -89.969574716',
  },
  {
    status: 'reporting',
    node: 'W01B',
    city: 'Lewistown, Illinois',
    gps: '40.35067872123443, -90.08610984360944',
  },
  {
    status: 'reporting',
    node: 'W020',
    city: 'Lewistown, Illinois',
    gps: '40.36136989389937, -90.09404779520423',
  },
  {
    status: 'reporting',
    node: 'W023',
    city: 'Lemont, Illinois',
    gps: '41.717805, -87.978575',
  },
  {
    status: 'reporting',
    node: 'W026',
    city: 'Chicago, Illinois',
    gps: '41.885712, -87.629559',
  },
  {
    status: 'reporting',
    node: 'W027',
    city: 'Lemont, Illinois',
    gps: '41.71845439954644, -87.98398166798243',
  },
  {
    status: 'reporting',
    node: 'W055',
    city: 'Chicago, Illinois',
    gps: '41.870282834, -87.675855163',
  },
  {
    status: 'reporting',
    node: 'W065',
    city: 'Chicago, Illinois',
    gps: '41.997176399, -87.765821455',
  },
  {
    status: 'reporting',
    node: 'W069',
    city: 'Lahaina, Hawaii',
    gps: '20.890681042619217, -156.65474422852128',
  },
  {
    status: 'reporting',
    node: 'W06E',
    city: 'Chicago, Illinois',
    gps: '41.98500232, -87.787872713',
  },
  {
    status: 'reporting',
    node: 'W071',
    city: 'Kaneohe, Hawaii',
    gps: '21.41130215, -157.7842519',
  },
  {
    status: 'reporting',
    node: 'W07A',
    city: 'Chicago, Illinois',
    gps: '41.884519582456015, -87.63675645813265',
  },
  {
    status: 'reporting',
    node: 'W07B',
    city: 'Chicago, Illinois',
    gps: '41.88462057460574, -87.62464411996037',
  },
  {
    status: 'reporting',
    node: 'W07D',
    city: 'Chicago, Illinois',
    gps: '41.83103500475166, -87.6171914776757',
  },
  {
    status: 'reporting',
    node: 'W07E',
    city: 'Chicago, Illinois',
    gps: '41.7947, -87.615865',
  },
  {
    status: 'reporting',
    node: 'W088',
    city: 'Chicago, Illinois',
    gps: '41.880655721, -87.745457066',
  },
  {
    status: 'reporting',
    node: 'W097',
    city: 'Pahoa, Hawaii',
    gps: '19.415203653, -155.238319893',
  },
  {
    status: 'reporting',
    node: 'W0AE',
    city: 'Lemont, Illinois',
    gps: '41.701339, -87.995624',
  },
  {
    status: 'reporting',
    node: 'W0AF',
    city: 'Lemont, Illinois',
    gps: '41.701339, -87.995624',
  },
  {
    status: 'reporting',
    node: 'W0B4',
    city: 'Lemont, Illinois',
    gps: '41.701339, -87.995624',
  },
  {
    status: 'reporting',
    node: 'W0B5',
    city: 'Lemont, Illinois',
    gps: '41.701339, -87.995624',
  },
  {
    status: 'reporting',
    node: 'W0B6',
    city: 'Lemont, Illinois',
    gps: '41.701339, -87.995624',
  }
];

function App() {
  const [nodes, setNodes] = useState([]);
  const [filteredNodes, setFilteredNodes] = useState([]);
  const [filterOptions, setFilterOptions] = useState({
    status: [],
    city: [],
  });
  const [selectedFilters, setSelectedFilters] = useState({
    status: [],
    city: [],
  });
  const [searchQuery, setSearchQuery] = useState('');
  const [currentTime, setCurrentTime] = useState('');
  const [mapHeight, setMapHeight] = useState(400);

  useEffect(() => {
    // Process the nodesData
    const parsedData = nodesData
      .map((row) => {
        const coords = row.gps ? row.gps.split(',') : [];
        if (coords.length !== 2) {
          console.error('Invalid GPS coordinates:', row.gps);
          return null;
        }

        const lat = parseFloat(coords[0]);
        const lng = parseFloat(coords[1]);
        if (isNaN(lat) || isNaN(lng)) {
          console.error('Invalid latitude or longitude for row:', row);
          return null;
        }

        return {
          status: row.status,
          node: row.node,
          city: row.city,
          coords: { lat, lng },
          gps: row.gps,
          popupText: `<div><b>Node:</b> <a href="/node/${row.node}" onclick="window.open('/node/${row.node}', '_self')">${row.node}</a><br><b>Status:</b> ${row.status}<br><b>City:</b> ${row.city}<br><b>GPS:</b> ${row.gps}</div>`,
        };
      })
      .filter((row) => row !== null);

    setNodes(parsedData);
    setFilteredNodes(parsedData);

    const uniqueValues = (key) => Array.from(new Set(parsedData.map((node) => node[key]))).sort();
    setFilterOptions({
      status: uniqueValues('status'),
      city: uniqueValues('city'),
    });
  }, []);

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const seconds = now.getSeconds();
      const timeString = `${hours}:${minutes.toString().padStart(2, '0')}:${seconds
        .toString()
        .padStart(2, '0')} ${hours >= 12 ? 'PM' : 'AM'}`;
      setCurrentTime(timeString);
    };

    const timer = setInterval(updateTime, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    const lowercasedQuery = searchQuery.toLowerCase();
    const filtered = nodes.filter((node) => {
      const matchesSearch = Object.values(node).some((value) =>
        value.toString().toLowerCase().includes(lowercasedQuery)
      );
      return (
        matchesSearch &&
        (selectedFilters.status.length === 0 || selectedFilters.status.includes(node.status)) &&
        (selectedFilters.city.length === 0 || selectedFilters.city.includes(node.city))
      );
    });
    setFilteredNodes(filtered);
  }, [nodes, selectedFilters, searchQuery]);

  const handleFilterChange = (selectedFilters) => {
    setSelectedFilters(selectedFilters);
  };

  const handleSearchChange = (query) => {
    setSearchQuery(query);
  };

  const handleMouseDown = (e) => {
    const startY = e.clientY;
    const startHeight = mapHeight;

    const handleMouseMove = (e) => {
      const delta = e.clientY - startY;
      setMapHeight(Math.max(200, Math.min(startHeight + delta, 800)));
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  // Set default map center based on average of all coordinates
  const getDefaultMapCenter = () => {
    const validNodes = nodes.filter(node => node.coords);
    if (validNodes.length === 0) return [41.85, -87.65]; // Default center (Chicago)

    const sumLat = validNodes.reduce((sum, node) => sum + node.coords.lat, 0);
    const sumLng = validNodes.reduce((sum, node) => sum + node.coords.lng, 0);
    return [sumLat / validNodes.length, sumLng / validNodes.length];
  };

  return (
    <Router>
      <div className="App w-full min-h-screen flex flex-col">
        <Header nodeCount={filteredNodes.length} nodes={nodes} />
        <Routes>
          <Route
            path="/"
            element={
              <div className="flex-grow">
                <div className="container-fluid px-4">
                  <div className="row">
                    <div className="col-12 mb-4">
                      <Map 
                        nodes={filteredNodes} 
                        mapHeight={mapHeight} 
                        defaultCenter={getDefaultMapCenter()}
                        defaultZoom={4}
                      />
                      <div
                        className="w-full cursor-row-resize"
                        onMouseDown={handleMouseDown}
                        style={{
                          height: '10px',
                          backgroundColor: '#ccc',
                          margin: '5px 0',
                        }}
                      ></div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 mb-4">
                      <Filters
                        filters={filterOptions}
                        selectedFilters={selectedFilters}
                        onFilterChange={handleFilterChange}
                        onSearchChange={handleSearchChange}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div id="nodesTableContainer">
                        <NodesTable data={filteredNodes} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          />
          <Route path="/node/:nodeId" element={<NodeDetails />} />
        </Routes>
        <DataSource />
      </div>
    </Router>
  );
}

export default App;